import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Carolina M.',
    role: 'Mamma di 2 bambini',
    quote: 'Mi ha salvato la vita. Prima passavo ore a pensare cosa cucinare e finivo per comprare qualsiasi cosa. Ora preparo le merende in 15 minuti e mangiano sanissimo.',
    initial: 'C'
  }, {
    name: 'Lucia P.',
    role: 'Mamma di 1 bambina',
    quote: 'Mia figlia era super selettiva, non voleva provare niente di nuovo. Con le ricette ha iniziato a mangiare verdure senza accorgersene. Un successo totale!',
    initial: 'L'
  }, {
    name: 'Valeria S.',
    role: 'Mamma di 3 bambini',
    quote: "L'organizzazione settimanale è oro puro. Non butto più cibo e risparmio un sacco al supermercato. Le ricette sono buonissime e facili.",
    initial: 'V'
  }, {
    name: 'Francesca G.',
    role: 'Mamma di 1 bambino',
    quote: 'Le ricette di pane senza glutine sono incredibili. Mio figlio è celiaco e facevo sempre fatica a trovare opzioni gustose per la sua merenda.',
    initial: 'F'
  }, {
    name: 'Camilla V.',
    role: 'Mamma di 2 bambine',
    quote: "Non avrei mai pensato che preparare le merende potesse essere così facile. I bonus sono un regalo spettacolare, soprattutto quello sull'organizzazione.",
    initial: 'C'
  }, {
    name: 'Marianna L.',
    role: 'Mamma di 1 bambino',
    quote: 'Ottimo investimento. Le ricette usano ingredienti che ho già in casa, niente di strano o costoso. Mio figlio felice e io più serena.',
    initial: 'M'
  }];
  return <section className="bg-gray-50 py-16 px-4" data-id="element-201">
      <div className="max-w-6xl mx-auto" data-id="element-202">
        <div className="text-center mb-12" data-id="element-203">
          <h2 className="text-3xl md:text-4xl font-extrabold text-[#1f2e10]" data-id="element-204">
            Guarda l'opinione delle mamme che usano{' '}
            <span className="text-green-600" data-id="element-205">Merende Felici</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-206">
          {testimonials.map((testimonial, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white p-6 rounded-2xl shadow-md border border-gray-100 relative" data-id="element-207">
              <div className="absolute -top-3 -right-3 bg-green-500 text-white text-xs font-bold px-3 py-1 rounded-full flex items-center gap-1 shadow-sm" data-id="element-208">
                <CheckCircle2 size={12} data-id="element-209" /> Approvato
              </div>
              <div className="flex gap-1 mb-4 text-[#c4f000]" data-id="element-210">
                {[1, 2, 3, 4, 5].map(star => <svg key={star} className="w-5 h-5 fill-current" viewBox="0 0 20 20" data-id="element-211">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-212" />
                  </svg>)}
              </div>
              <p className="text-gray-700 italic mb-6 leading-relaxed" data-id="element-213">
                "{testimonial.quote}"
              </p>
              <div className="flex items-center gap-3" data-id="element-214">
                <div className="w-10 h-10 rounded-full bg-[#1f2e10] text-[#c4f000] flex items-center justify-center font-bold text-lg" data-id="element-215">
                  {testimonial.initial}
                </div>
                <div data-id="element-216">
                  <h4 className="font-bold text-[#1f2e10]" data-id="element-217">
                    {testimonial.name}
                  </h4>
                  <p className="text-xs text-gray-500" data-id="element-218">{testimonial.role}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}